module.exports = __webpack_public_path__ + "static/media/hostplatform-logo-icon.80730bae.png";